import { render } from "./DepartementTable.vue?vue&type=template&id=625f2f5c"
import script from "./DepartementTable.vue?vue&type=script&lang=js"
export * from "./DepartementTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__